import React from "react";
import JSONView from "../components/JSONView";

import { useAuthFunctions } from "../contexts/Auth";

import Loading from "../components/Loading";

export default function IDPResponse() {
  const auth = useAuthFunctions();
  const [query_json, setQueryJson] = React.useState({
    state: "Processing",
  });
  const [token_json, setTokenJson] = React.useState({
    state: "Processing",
  });

  const debug = false;

  React.useEffect(() => {
    console.log("loaded idpresponse.js");
    const query = window.location.search;
    const params = new URLSearchParams(query);
    const new_query_json = {};
    for (const [key, value] of params) {
      new_query_json[key] = value;
    }
    setQueryJson(new_query_json);
    if (new_query_json.code) {
      auth.getFederatedTokens(new_query_json.code).then((response) => {
        setTokenJson(response);
        // Then go home
        window.location.href = "/";
      });
    }
  }, []);

  return (
    <>
      {debug ? (
        <div>
          <h1>IDPResponse</h1>
          <p>Query</p>
          <JSONView target_object={query_json} />
          <p>Token</p>
          <JSONView target_object={token_json} />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#f0f0f0", // Optional: Set a background color
          }}
        >
          <Loading message="Processing IDP Response..." />
        </div>
      )}
    </>
  );
}
